import { render, staticRenderFns } from "./StoreDetail.vue?vue&type=template&id=205a254a&scoped=true"
import script from "./StoreDetail.vue?vue&type=script&lang=ts"
export * from "./StoreDetail.vue?vue&type=script&lang=ts"
import style0 from "./StoreDetail.vue?vue&type=style&index=0&id=205a254a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205a254a",
  null
  
)

export default component.exports